
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/forfaits-de-ski",
      function () {
        return require("private-next-pages/[region]/[resort]/forfaits-de-ski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/forfaits-de-ski"])
      });
    }
  